import moment from 'moment';
import React, { useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { Card, CardContent, Grid, Typography, makeStyles } from '@material-ui/core';
import { AddBoxRounded } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import Theme from '../ui/Theme';
import { getTopicOfTheMonth, showProgress } from '../../redux/actions/DealershipActions';
import AddNewTopicPopup from './AddNewTopicPopup';
import { ErrorToast } from '../utils/Utils';
import Service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
const useStyles = makeStyles(() => ({
  addIcon: {
    height: '40px',
    width: '40px',
    color: '#622FEE',
    cursor: 'pointer',
  },
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
  },
  collectionName: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '20px',
  },
  secondaryText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
  },
  root: {
    backgroundColor: Theme.palette.secondary.main,
    height: '48px',
  },
  tomListBackground: {
    backgroundColor: Theme.palette.secondary.main,
    padding: '10px',
    maxHeight: '70vh',
    height: '70vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  cardContent: {
    borderRadius: '8px',
    marginBottom: '10px',
    height: '58px',
    cursor: 'pointer',
  },
  selectedCardContent: {
    backgroundColor: 'var(--brand-50, #F4F3FF)',
    border: '1px solid var(--brand-300, #BEB3FF)',
    marginBottom: '10px',
    height: '58px',
    borderRadius: '8px',
    cursor: 'pointer',
  },
}));

export default function TopicList() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const topicOfTheMonthList = useSelector((state) => state.getTopicOfTheMonth.selectedDateData) || [];
  const topicOfTheMonthSelectedId = useSelector((state) => state.getTopicOfTheMonth.selectedTopicId);
  const topicOfTheMonthDatesList = useSelector((state) => state.getTopicOfTheMonth.datesList);

  const [topicIsAddOpen, setIsTopicAddOpen] = useState(false);

  const handleClickTopic = (topicId) => {
    if (topicId !== topicOfTheMonthSelectedId) {
      dispatch(getTopicOfTheMonth('SET_TOPIC_ID', topicId));
    }
  };

  const handleTopicAddClick = () => {
    setIsTopicAddOpen(true);
  };

  const handleTopicAddClose = async (topicDate = null, isTopicAdded = false) => {
    dispatch(showProgress(true));
    let date;

    // if topic is added
    if (topicDate && isTopicAdded) {
      // if topic date in sidebar list then fetch data for date
      date = topicOfTheMonthDatesList.find((d) => d.title === moment(topicDate).format('MMMM, YYYY'));

      // if date not in sidebar then refresh sidebar date list
      if (_isEmpty(date)) {
        try {
          const response = await Service.get(apiEndpoints.TOM_DATES);
          dispatch(getTopicOfTheMonth('SET_DATES_LIST', response));
          date = response.find((d) => d.title === moment(topicDate).format('MMMM, YYYY'));
        } catch (err) {
          ErrorToast(err);
        }
      }

      // fetch topic by date
      if (!_isEmpty(date)) {
        try {
          dispatch(getTopicOfTheMonth('SET_DATE', date));
          const response = await Service.post(apiEndpoints.TOM_TOPICS_BY_DATES, {
            date: date.date,
          });
          dispatch(getTopicOfTheMonth('SET_DATE_DATA', response));
          if (!_isEmpty(response)) {
            dispatch(getTopicOfTheMonth('SET_TOPIC_ID', response[0].id));
          }
        } catch (err) {
          ErrorToast(err);
        }
      } else {
        ErrorToast('Something went wrong');
      }
    }
    dispatch(showProgress(false));
    setIsTopicAddOpen(false);
  };

  return (
    <div>
      <Grid container alignItems="center" className={classes.root}>
        <Grid item xs={10}>
          <Typography className={classes.primaryText} noWrap>
            Ongoing Topics
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <AddBoxRounded className={classes.addIcon} onClick={handleTopicAddClick} />
        </Grid>
      </Grid>
      <br />
      <Grid container className={classes.tomListBackground} alignContent="flex-start">
        {topicOfTheMonthList.map((tom) => (
          <Grid style={{ width: '100%' }} item key={tom.id}>
            <Card
              className={tom.id === topicOfTheMonthSelectedId ? classes.selectedCardContent : classes.cardContent}
              onClick={() => handleClickTopic(tom.id)}
            >
              <CardContent>
                <Grid container direction="column" alignItems="space-between">
                  <Grid item>
                    <Typography noWrap className={classes.collectionName}>
                      {tom.title}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography noWrap className={classes.secondaryText}>
                      {tom.dealershipCount || 0} dealerships
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {topicIsAddOpen && <AddNewTopicPopup closePopup={(date, isAdded) => handleTopicAddClose(date, isAdded)} />}
    </div>
  );
}
